import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
@Component({
    selector: 'app-range-slider',
    imports: [NgxSliderModule, FormsModule, ReactiveFormsModule],
    templateUrl: './range-slider.component.html',
    styleUrl: './range-slider.component.scss'
})
export class RangeSliderComponent {
@Input() field: any = {};
  @Input() form!: FormGroup;
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }

  value: number = 20;
  highValue: number = 100;

  options!: Options
  get getValue() {
    return this.form.value[this.field.name]
  }
  constructor() { }

  ngOnInit(): void {
    this.options = {
      floor: this.getValue[0],   // Minimum value
      ceil: this.getValue[1],  // Maximum value
      hideLimitLabels: true,
      translate: (value: number): string => {
        return `<b>${value}</b>`;
      }
    };
  }

}
